import React from 'react';
import { faGrip } from '@fortawesome/sharp-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, useTheme } from '@mui/material';

/**
 * Composant de poignée pour déplacer la fenêtre modale
 */
export const DragHandle: React.FunctionComponent = function () {
    const theme = useTheme();
    return (
        <Box
            id="draggable-dialog-title"
            sx={{
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '160px',
                height: '36px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'move',
                zIndex: 1,
                pointerEvents: 'auto',
                '&:hover': {
                    '& .grip-icon': {
                        opacity: 0.9,
                        transform: 'translateY(0)',
                    },
                },
            }}
        >
            <Box
                className="grip-icon"
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(180, 180, 180, 0.15)',
                    borderRadius: '4px',
                    padding: '3px 10px',
                    transition: 'all 0.2s ease-in-out',
                    opacity: 0.5,
                    transform: 'translateY(2px)',
                    width: '80px',
                }}
            >
                <FontAwesomeIcon
                    icon={faGrip}
                    size="xs"
                    style={{
                        color: theme.palette.text.secondary,
                    }}
                />
            </Box>
        </Box>
    );
};
